import type { OrgOnboardingSessionStatus } from "~/lib/org-onboarding/types";
import type { OnboardingSessionChannel } from "~/lib/org-onboarding/onboarding-channels";

export const SITEGLUE_ONBOARDING_SESSION_KEY = "egpt-siteglue-onboarding-session-key";

export function getOrCreateOnboardingSessionKey(storageKey: string): string {
  if (typeof window === "undefined") return "server";
  try {
    const existing = sessionStorage.getItem(storageKey);
    if (existing) return existing;
    const key = `onboarding-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;
    sessionStorage.setItem(storageKey, key);
    return key;
  } catch {
    return `onboarding-${Date.now()}`;
  }
}

export async function trackOnboardingSession(input: {
  brandSlug: string;
  sessionKey: string;
  status?: OrgOnboardingSessionStatus;
  websiteUrl?: string | null;
  visitorEmail?: string | null;
  visitorName?: string | null;
  channel?: OnboardingSessionChannel;
  metadata?: Record<string, unknown>;
}) {
  try {
    await fetch("/api/partner-onboarding/session", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        ...input,
        metadata: {
          ...(input.metadata ?? {}),
          ...(input.channel ? { channel: input.channel } : {}),
        },
      }),
    });
  } catch {
    /* non-blocking analytics */
  }
}
